<template>
  <div class="invoice-dense-tab">
    <div class="invoice-dense-table-wrap">
      <b-table
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        hover
        responsive
        small
        :busy="loading"
        show-empty
        class="invoice-dense-table mb-0"
      >
        <template #table-busy>
          <div class="invoice-dense-state invoice-dense-state--loading">
            <b-spinner small class="mr-50" />
            <span>Loading financial data…</span>
          </div>
        </template>
        <template #empty>
          <div class="invoice-dense-state">
            <div class="invoice-dense-empty-icon">
              <feather-icon icon="DollarSignIcon" size="28" />
            </div>
            <h6 class="mb-25">No financial data</h6>
            <p class="text-muted mb-1">
              {{ searchActive ? 'Try a different search or clear it.' : 'No invoice amounts match the current filters.' }}
            </p>
            <b-button v-if="searchActive" size="sm" variant="outline-secondary" @click="$emit('clear-search')">
              Clear search
            </b-button>
          </div>
        </template>
        <template #cell(invoice_id)="{ item }">
          <div class="inv-cell-stack">
            <span class="inv-primary-text text-nowrap">{{ item.invoice_id || 'N/A' }}</span>
            <small class="text-muted text-nowrap">{{ formatDate(item.invoice_date) || 'N/A' }}</small>
          </div>
        </template>
        <template #cell(base_amount)="{ item }">
          <span class="inv-amount">₹{{ formatIndianNumber(item.base_amount) }}</span>
        </template>
        <template #cell(total_amount)="{ item }">
          <span class="inv-amount">₹{{ formatIndianNumber(item.total_amount) }}</span>
        </template>
        <template #cell(paid_amount)="{ item }">
          <span class="inv-amount">₹{{ formatIndianNumber(item.paid_amount) }}</span>
        </template>
        <template #cell(pending_amount)="{ item }">
          <span class="inv-amount">₹{{ formatIndianNumber(item.pending_amount) }}</span>
        </template>
      </b-table>
    </div>
    <div v-if="totalRows > perPage" class="invoice-dense-pagination">
      <b-pagination
        :value="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        @change="$emit('page-change', $event)"
      />
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner, BPagination, BButton } from 'bootstrap-vue'
import invoiceFormatMixin from '@/mixins/invoiceFormatMixin'

export default {
  name: 'ReconFinancialTab',
  components: { BTable, BSpinner, BPagination, BButton },
  mixins: [invoiceFormatMixin],
  props: {
    items: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    perPage: { type: Number, default: 10 },
    currentPage: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
    searchActive: { type: Boolean, default: false }
  },
  emits: ['page-change', 'clear-search']
}
</script>

<style lang="scss">
@import '../tabs/invoice-dense-tab.scss';
</style>
